export * from '@uifabric/icons';
//# sourceMappingURL=Icons.js.map